// Recovered compiled webpack factory 36851. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { C: () => n });
  let n = new WeakMap();
}
